module.exports = __webpack_public_path__ + "img/转型路线英文.1b0140e3.png";